import React, { Component } from 'react';
import * as util from '../../../../../utils/EnumMapping';
import MainTable from '../../../../common/table/MainTable';
import NewSalary from './NewSalary';
import SalaryAggregatePanel from './SalaryAggregatePanel';
import * as columns from './SalaryColumns';
class Salary extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "SALARY";
            item.paymentMethodLabel = util.getLabel(util.outPaymentMethods, item.paymentMethod);
            item.stateLabel = util.getLabel(util.states, item.state);
            return item;
        })
        return data;
    }

    render() {
        return (
            <>
                {/* <LinkTab tabs={tabs} index={0} /> */}
                <MainTable
                    divClassName="salary"
                    tableName="Fizetések"
                    newObjectLabel="Új fizetés hozzáadása"
                    path='/api/salaries'
                    enrich={this.enrich}
                    columns={(props) => columns.columns(props)}
                    dialogContent={(refresh, close) => <NewSalary refresh={refresh} close={close} />}
                    needAggregate={true}
                    aggregatePanel={(rows) => <SalaryAggregatePanel rows={rows} />
                    } />
            </>
        );
    }
}

export default Salary;